import { render, staticRenderFns } from "./Form04.vue?vue&type=template&id=6dd78856&scoped=true"
import script from "./Form04.vue?vue&type=script&lang=js"
export * from "./Form04.vue?vue&type=script&lang=js"
import style0 from "./Form04.vue?vue&type=style&index=0&id=6dd78856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd78856",
  null
  
)

export default component.exports